/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
import React, {useState} from 'react';
import {Formik, Form} from 'formik';
import TextInput from 'src/components/input/TextInput';
import {
	Box,
	Button,
	Card,
	CardContent,
	IconButton,
	Link,
	Typography,
} from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import {To, useNavigate} from 'react-router-dom';
import {useLoginMutation} from 'src/redux/api/authApi';
import {Visibility, VisibilityOff} from '@mui/icons-material';
import {esquemaDeValidacionLogin, valoresInicialesLogin} from './utils';

function Login() {
	const navigate = useNavigate();
	const [login, {isLoading: cargandoPeticion}] = useLoginMutation();
	const [showPassword, setShowPassword] = useState(false);

	const handleLogin = (values: any) => {
		login(values)
			.unwrap()
			.then((resp) => {
				// navigate('/gestion', {replace: true});
				navigate(resp.redirectTo as To, { replace: true });
			})
			.catch(() => {
				/* empty */
			});
	};

	const handleTogglePassword = () => {
		setShowPassword(!showPassword);
	};

	return (
		<Box
			sx={{
				width: '100%',
				minHeight: '100%',
				flexGrow: 1,
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				justifyContent: 'center',
			}}
			data-testid="login"
		>
			<Card
				variant="elevation"
				sx={{
					minWidth: {xs: '85%', md: '350px'}, padding: {xs: 2, md: 3}, marginY: 3, marginX: {xs: 3, md: 0},
				}}
			>
				<CardContent>
					<Typography variant="h5" component="div" gutterBottom align="left">
						Inicio de sesión
						<br />
						<br />
					</Typography>
					<Formik
						initialValues={valoresInicialesLogin}
						validationSchema={esquemaDeValidacionLogin}
						onSubmit={handleLogin}
					>
						<Form autoComplete="off">
							<TextInput label="E-mail" name="correo" type="email" InputLabelProps={{shrink: true}} />
							<TextInput
								label="Contraseña"
								name="contrasena"
								type={showPassword ? 'text' : 'password'}
								InputProps={{
									endAdornment: (
										<IconButton onClick={handleTogglePassword} edge="end" data-testid="boton-mostrar-contrasena">
											{showPassword ? <Visibility /> : <VisibilityOff />}
										</IconButton>
									),
								}}
								InputLabelProps={{shrink: true}}
							/>
							<Typography align="left">
								<Link href="/perseo/#/envio-correo-recuperacion" variant="body2">¿Olvidaste tu contraseña?</Link>
								<br />
								<br />
							</Typography>

							<Box display="flex" flexDirection="column" gap={2} marginTop={2}>
								<LoadingButton loading={cargandoPeticion} variant="contained" type="submit" data-testid="boton-iniciar-sesion">
									Iniciar sesión
								</LoadingButton>
								{/* <Button role="link" href="/perseo/#/registro">
									Registrarse
								</Button> */}
							</Box>
						</Form>
					</Formik>
				</CardContent>
			</Card>
		</Box>
	);
}

export default Login;
